export default "__VITE_ASSET__1491d638__"